import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMobileSdkTests } from 'src/apps/mobile-sdk/services/MobileSdkDashboardService';
import { TMobileSdkTestsResult } from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';
import { MOBILE_SDK_TESTS } from 'src/common/providers/reactQueryProvider/QueryKeys';
import { ITableQueryParams } from 'src/common/types/TableQueryTypes';
import { IUseTableQueryParams } from 'src/common/types/UseTableQueryParamsType';

interface IUseMobileSdkTestsQueryParams extends IUseTableQueryParams {
	showRecentTest: boolean;
}

export const useMobileSdkTestsQuery = ({
	showRecentTest,
	filters,
	sort,
	page,
	pageSize
}: IUseMobileSdkTestsQueryParams): UseQueryResult<TMobileSdkTestsResult> => {
	return useQuery(
		[MOBILE_SDK_TESTS, showRecentTest, filters, sort, page, pageSize],
		async (): Promise<TMobileSdkTestsResult> =>
			getMobileSdkTests({
				isRecentTests: showRecentTest,
				filterOptions: filters as ITableQueryParams['filterOptions'],
				sort,
				page,
				pageSize
			}),
		{
			keepPreviousData: true
		}
	);
};
